import React, { useEffect } from "react";
import styled from "styled-components";
import PerspectiveComponent from "./PerspectiveComponent";
import ObjectivesComponent from "./ObjectivesComponent";
import KPIsComponent from "./KPIsComponent";
import { useRouteMatch, Switch, Route } from "react-router-dom";
import { is360Subject } from "../../../subjects/Is360Subject";
import KPIConfigComponent360 from "./KPIConfigComponent360";
import GlobalSearchKpi from "../GlobalSearch/GlobalSearchKpi";

export const ScorecardConfig = () => {
  const { path, params } = useRouteMatch();
  // console.log({ is360: is360Subject });
  useEffect(() => {
    const is360Sub = is360Subject.subscribe((payload) => {
    });
    return () => {
      is360Sub.unsubscribe();
    };
  });
  const is360 = is360Subject.value;
  return (
    <ScorecardSettingsContainer>
      <Switch>
        <Route path={`${path}`} component={PerspectiveComponent} />
      </Switch>
      <Route path={`${path}/perspective/:id`} component={ObjectivesComponent} />
      <Route
        path={`${path}/perspective/:id/objective/:id`}
        component={is360 ? KPIConfigComponent360 : KPIsComponent}
      />
    </ScorecardSettingsContainer>
  );
};

const ScorecardSettingsContainer = styled.div`
  display: grid;
  background-color: #fff;
  grid-template-columns: 18em 18em auto;
  box-shadow: 0px 10px 20px rgba(55, 81, 255, 0.1);
`;
